import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import React from "react";
import { Link } from "react-router-dom";

function Sidebar({ isOpen }) {
  return (
    <div className={`sidebar ${isOpen ? "open" : "collapsed"}`}>
      <div className="logo">
        <h5>Interior </h5>
      </div>

      <ul className="menu list-unstyled">
        <li>
          <Link to="/">
            <i className="bi bi-speedometer2 me-2"></i>
            {isOpen && "Dashboard"}
          </Link>
        </li>
        <li>
          <Link to="/projects">
            <i className="bi bi-building me-2"></i>
            {isOpen && "Projects"}
          </Link>
        </li>
        <li>
          <Link to="/clients">
            <i className="bi bi-people me-2"></i>
            {isOpen && "Clients"}
          </Link>
        </li>
        <li>
          <Link to="/WorkerMaster">
            <i className="bi bi-people me-2"></i>
            {isOpen && "WorkerMaster"}
          </Link>
        </li>
        <li>
          <Link to="/settings">
            <i className="bi bi-gear me-2"></i>
            {isOpen && "Settings"}
          </Link>
        </li>
        <li>
          <Link to="/TransactionMaster">
            <i className="bi bi-gear me-2"></i>
            {isOpen && "Transaction"}
          </Link>
        </li>
      </ul>
    </div>
  );
}

export default Sidebar;
